module.exports = {
    apiUrl: '/api',
    baseURL: '/',
        landingAssetsURL: '/placementtest3',
        ge_redirect_url: '/placementtest/auth',
        ge_client_id: 'ic-connect',
        ge_authorization_url: 'https://im-id.icanx.vn/oauth2/auth',
}
